module.exports = __webpack_public_path__ + "media/images/logos/pinpoint-53624156d36189abc5b0c5c3e79101ce.png";